import {
  Copy,
  Flex,
  Heading,
  Image,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';
import { BURGER_AND_FRIES_IMAGE_URL } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelBanner/utils/getOnboardingFunnelBannerCopy.utils';

export interface OnboardingFunnelBannerProps {
  headerText: string;
  bodyText: string;
  buttonText: string;
  href: string;
}

export function OnboardingFunnelBanner({
  headerText,
  bodyText,
  buttonText,
  href,
}: OnboardingFunnelBannerProps): JSX.Element {
  return (
    <PageSection>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Stack x="lg">
            <Image
              src={BURGER_AND_FRIES_IMAGE_URL}
              alt="Burger and fries"
              width="80px"
              height="80px"
            />
          </Stack>
          <Flex flexDirection="column">
            <Stack y="xxx-sm">
              <Heading variant="h4">{headerText}</Heading>
            </Stack>
            <Copy variant="body">{bodyText}</Copy>
          </Flex>
        </Flex>
        <Flex alignItems="center" justifyContent="flex-end">
          <RouterButtonLink
            href={href}
            buttonVariant="primary"
            buttonSize="large"
          >
            <Flex alignItems="center" justifyContent="center" height="100%">
              {buttonText}
            </Flex>
          </RouterButtonLink>
        </Flex>
      </Flex>
    </PageSection>
  );
}
